import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import sentiment from "../../../Assets/Projects/NLP/Shoope.png";
import sentiment2 from "../../../Assets/Projects/NLP/Shoope2.png";
import sentiment3 from "../../../Assets/Projects/NLP/Shoope3.png";
import sentiment4 from "../../../Assets/Projects/NLP/Shoope4.png";
import sentiment5 from "../../../Assets/Projects/NLP/Shoope5.png";

function SentimentAnalysisSPayLater() {
  return (
    <ProjectDetailCard
      title="Sentiment Analysis of SPayLater & SPinjam Reviews"
      image={sentiment}
      screenshots={[sentiment2, sentiment3, sentiment4]}
      description="
      Sentiment Analysis of SPayLater & SPinjam Reviews is a Natural Language Processing (NLP) project developed to analyze customer opinions collected from online reviews. The system automatically classifies user feedback into positive, neutral, and negative sentiments, enabling a deeper understanding of customer satisfaction and public perception toward digital financial services. The application includes data preprocessing, text visualization, sentiment classification, and evaluation to provide meaningful insights that can support service improvement and strategic decision-making.
      "
      technologies={[
        "Python",
        "Scikit-learn",
        "NLTK",
        "TF-IDF",
        "Sastrawi",
        "Pandas",
        "NumPy",
        "Matplotlib",
        "WordCloud",
        "Jupyter",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={sentiment5} alt="gallery1" />
          <img src={sentiment4} alt="gallery2" />
          <img src={sentiment3} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default SentimentAnalysisSPayLater;
